import React, { Component } from 'react'
import {
  Form, Input, Select
} from 'antd'
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux'


const Option = Select.Option;

class CustomerServiceForm extends Component {
  constructor(props) {
    
    super(props);
    this.state = {
      
      //控制disabled是否显示
      dis:true
    };
  }
  showDisable(){
    if(this.props.roleId=='3'){
      this.setState({dis:true})
    }else{
      this.setState({dis:false})
    }
  }
  render() {
    const {t,fieldChange,countryList,operatorCodeList,customerService} = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
      },
    }
    return (
      <div>
        <Form {...formItemLayout}>
          <Form.Item label={t("Name")}>
            <Input defaultValue={customerService.name} onChange={(e)=>{fieldChange('name',e.target.value)}}></Input>
          </Form.Item>
          {/* <Form.Item label={t("Country/Region")}>
            <Select disabled={this.state.dis}  defaultValue={customerService.countryCode} onChange={(value)=>{fieldChange('countryCode',value)}}>
              {
                countryList.map((country)=>(<Option key={country.countryCode}>{country.countryName}({country.countryCode})</Option>))
              }
            </Select>
          </Form.Item> */}
          <Form.Item label={t("Carrier Code")}>
            <Select disabled={this.state.dis} defaultValue={customerService.operator} onChange={(value)=>{fieldChange('operator',value)}}>
              {
                operatorCodeList.map((operator)=>(<Option key={operator}>{operator}</Option>))
              }
            </Select>
          </Form.Item>
          <Form.Item label={t("Phone Number")}>
            <Input defaultValue={customerService.phoneNumber} onChange={(e)=>{fieldChange('phoneNumber',e.target.value)}}></Input>
          </Form.Item>
          <Form.Item label={t("QR Code Link")}>
            <Input defaultValue={customerService.link} onChange={(e)=>{fieldChange('link',e.target.value)}}></Input>
          </Form.Item>
          <Form.Item label={t('APK White List')}>
            <Input.TextArea defaultValue={customerService.apkWhiteList} onChange={(e)=>{fieldChange('apkWhiteList',e.target.value)}}></Input.TextArea>
          </Form.Item>
        </Form>
      </div>
    )
  }
  componentDidMount(){
    this.showDisable()
  }
}

const mapStateToProps = (state)=>{
  return {
    roleId:state.roleId,
  }
}

export default connect(mapStateToProps)(withTranslation()(CustomerServiceForm));